/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import h from "util/dom-builder.js";

var FeedbackViewModel = function(params) {
	var self = this;

	self.state = ko.observable('idle'); // 'send', 'error'

	self.feedbackMessage = ko.observable('');
	self.userEmail = ko.observable('');

	var data = {
		userAgent: navigator.userAgent,
		url: document.location.href,
		screen: {
			width: screen.width,
			height: screen.height
		}
	};

	birdata.me(true).noLoginRedirect().catch(function() { return {}; }).then(function(user) {
		data.user = user;

		if(user.email && !self.userEmail()) {
			self.userEmail(user.email);
		}

		console.log(JSON.stringify(data, null, 2));
	});

	setTimeout(function() {
		document.querySelector(".feedback textarea").focus();
	},50);

	self.canSend = ko.pureComputed(function() {
		return !!(self.feedbackMessage() && self.userEmail());
	});

	self.cancel = function() {
		destroyFeedbackComponent();
	};

	self.dismiss = function() {
		destroyFeedbackComponent();
	};

	self.send = function() {
		self.state('send');
		birdata.submitFeedback({
			message: self.feedbackMessage(),
			user_email: self.userEmail(),
			user_info: data
		}).then(function() {
			self.state('success');
		}).catch(function(e) {
			self.state('error');
			console.log("Error submitting feedback");
			throw e;
		});
	};
};

ko.components.register('feedback', {
	viewModel: function(params) {
		return new FeedbackViewModel(params);
	},
	template: require('../../templates/feedback.html')
});

function destroyFeedbackComponent() {
	var el = document.querySelector(".birdata-embed .feedback").parentNode;
	el.parentNode.removeChild(el);
}

document.body.addEventListener("click", function(evt) {
	if(evt.target.closest && evt.target.closest('.show-feedback') != null) {
		var componentDiv = h('div', { 'class': 'birdata-embed', 'data-bind': 'component: "feedback"'});
		document.body.appendChild(componentDiv);
		ko.applyBindings(null, componentDiv);
	}
});

export default FeedbackViewModel;
